import styled from "@emotion/styled";

export const TradeDetailsRow = styled.div`
  color: ${props => props.theme.font.primary.default};
  font-size: ${props => props.theme.fontSize[5]};
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-self: stretch;
  flex-wrap: wrap;
  gap: 12px;
`;
